
export default (key) => {
    return `${key}.visible`
}
